// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-payment__email',
    // #endregion
    // #region Properties
    props: {
        data: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        cart: {
            type: Object,
            required: false,
            default: {}
        },
    },
    // #endregion
});
// #endregion
